// extracted by mini-css-extract-plugin
module.exports = {"phoneNumberWrapper":"styles_phoneNumberWrapper__1KOZR","phoneNumber":"styles_phoneNumber__3FHWj","morePhoneNumbers":"styles_morePhoneNumbers__1I467"};